export default {
  dashboard: 'Dashboard',
  orders: 'Pesanan',
  newOrderNavTitle: 'Ada pesanan baru',
  reports: 'Laporan',
  shippingProblem: 'Masalah Pengiriman',
  damageOrMissing: 'Kerusakan/Selisih',
  schedule: 'Jadwal',
  invoice: 'Invoice',
  invoiceTransporter: 'Invoice Rekanan 3PL',
  invoiceShipper: 'Invoice Customer',
  masterData: 'Master Data',
  invoiceData: 'Invoice Data',
  parameter: 'Parameter',
  baReception: 'Ba Penerimaan',
  customer: 'Customer',
  transporter: 'Rekanan 3PL',
  vehicleTypes: 'Tipe Kendaraan',
  category: 'Kategori',
  locations: 'Lokasi',
  allLocation: 'Semua Lokasi',
  additionalCost: 'Biaya Tambahan',
  selectionInfo: 'Pilihan dan Alasan',
  aboutUs: 'Tentang Kami',
  contactUs: 'Hubungi Kami',
  logout: 'Logout',
  documentReport: 'Laporan',
  userAdmin: 'User Admin',
  taxReport: 'Pajak',
  reporting: 'Dokumen',
}
